export default __webpack_public_path__ + "static/media/mortarboard.64192e06.svg";